<style scoped lang="scss">
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.cons{
  display: none;
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
//.table{
//  tr{
//    td:first-child{
//      background: #F6FAFD;
//    }
//  }
//}
.c-title small{
  margin-top: 10px;
}
.required{
  background: none!important;
  margin-left: 0!important;
}
.desc{
  font-size: 16px;
}
.c-title1{
  text-align: left;
  font-size: 18px;
  padding: 0;
}
.bg{
  background: rgba(210,210,210,0.8);
  color: #333;
  padding: 10px;
  text-align: center;
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.effect-lists{
  //display: block!important;
  justify-content: space-between;
  flex-wrap:wrap;
  overflow: auto;
}
.effect-lists1{
  justify-content: center;
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <div class="banner" v-if="!$route.meta.invisibles">
      <div class="con"><img src="@/assets/img/产品及服务/1.5代测序/banner.jpg" class="img-fluid"></div>
      <div class="cons"><img src="@/assets/img/二级标题Banner/Fast NGS.jpg" class="img-fluid"></div>
      <div class="info"></div>
    </div>
    <section v-if="!$route.meta.invisibles">
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container">
        <p class="desc" >Fast NGS是基于二代测序的创新测序技术，拥有一代测序准确性的同时兼具二代测序的高通量和低成本等优势。其在基于NGS的分子条形码技术中引入了一种消除错误的算法，无需引物即可准确分析1 kb以上的长片段。可应用于PCR产物或质粒(plasmid)样本，也可应用于基于NGS的各种测序，一次可实现100 bp-30 kb全序列检测。</p>
        <p class="desc" style="margin-top: 10px;">擎科生物采用独特的DNA建库技术，以低成本将单个样本分别建库，片段长度适用于300 bp-5 kb，样品类型为PCR产物或质粒DNA，可进行长片段、多序列测序组装分析。</p>
      </div>
      <div class="container">
        <div class="c-title">服务流程</div>
        <img src="@/assets/img/产品及服务/1.5代测序/1.5_lc.png" class="img-fluid con">
        <img src="@/assets/img/产品及服务/1.5代测序/1.5_lc.png" class="img-fluid cons" style="margin-top: 20px;">
      </div>
      <div class="container">
        <div class="c-title">服务参数</div>
        <table class="table">
          <tr>
            <th>参数</th>
            <th>Fast NGS</th>
          </tr>
          <tr>
            <td>测序平台</td>
            <td>Illumina平台  MiSeq测序仪</td>
          </tr>
          <tr>
            <td>DNA质检</td>
            <td>DNA浓度＞10 ng/μL, 总量＞200 ng，无明显降解</td>
          </tr>
          <tr>
            <td>测序策略</td>
            <td>Illumina PE150测序，PCR深度≥100X，质粒深度≥30X</td>
          </tr>
        </table>
      </div>
      <div class="container">
        <div class="c-title">交付结果</div>
        <p class="desc" style="text-indent: 0">A.数据质控：去除接头污染和低质量数据；</p>
        <p class="desc" style="text-indent: 0">B.序列（无参）拼接组装，交付质粒序列FASTA格式文件、深度图表；</p>
        <p class="desc" style="text-indent: 0">C.突变位点以简并碱基的形式输出，对应的深度统计表里查看具体的碱基类型。</p>
        <p class="desc" style="text-indent: 0">特别说明：重复序列或缺失突变过多可能组装不成功。</p>
      </div>
      <!-- <div class="container">
        <div class="c-title">参数及报价</div>
        <div class="c-title c-title1">1、全质粒测序（≥1个样品起送）</div>
        <table class="table con" style="margin-top: 20px;">
          <tr>
            <th style="width: 150px">质粒大小</th>
            <th style="width: 200px">测序深度</th>
            <th style="width: 200px">交付结果</th>
            <th style="width: 200px">备注</th>
          </tr>
          <tr>
            <td>＜5kb</td>
            <td rowspan="5">30X</td>
            <td  rowspan="5">
              1.拼接序列<br>
              2.深度图表
            </td>
            <td  rowspan="5" style="text-align: left;padding-left: 70px;">
              1.存在困难序列质粒不保证成环;<br>
              2.不保证重复序列区域拼接准确性;<br>
              3.一代测序补测费用另算。
            </td>
          </tr>
          <tr>
            <td>5kb-15kb</td>
          </tr>
          <tr>
            <td>15kb-30kb</td>
          </tr>
          <tr>
            <td>30kb-60kb</td>
          </tr>
        </table>
        <table class="table cons" style="margin-top: 20px;">
          <tr>
            <th style="width: 150px">质粒大小</th>
            <th style="width: 200px">测序深度</th>
            <th style="width: 200px">交付结果</th>
            <th style="width: 200px">备注</th>
          </tr>
          <tr>
            <td>＜5kb</td>
            <td rowspan="5">30X</td>
            <td  rowspan="5">
              1.拼接序列<br>
              2.深度图表
            </td>
            <td  rowspan="5" style="font-size: 12px!important;">
              1.存在困难序列质粒不保证成环;<br>
              2.不保证重复序列区域拼接准确性;<br>
              3.一代测序补测费用另算。
            </td>
          </tr>
          <tr>
            <td>5kb-15kb</td>
          </tr>
          <tr>
            <td>15kb-30kb</td>
          </tr>
          <tr>
            <td>30kb-60kb</td>
          </tr>
        </table>
        <div class="c-title c-title1" style="margin-top: 20px;">2、PCR产物测序（≥30个样品起送）</div>
        <table class="table con" style="margin-top: 20px;">
          <tr>
            <th style="width: 150px">片段大小</th>
            <th style="width: 200px">测序深度</th>
            <th style="width: 200px">交付结果</th>
            <th style="width: 200px">备注</th>
          </tr>
          <tr>
            <td>0.3 kb-1 kb</td>
            <td rowspan="4">100X</td>
            <td  rowspan="4">
              1.拼接序列<br>
              2.深度图表
            </td>
            <td  rowspan="4" style="text-align: left;padding-left: 70px;">
              1.需要提供参考序列;<br>
              2.不保证重复序列区域拼接准确性;<br>
              3.突变5%以上会以简并碱基形式输出。
            </td>
          </tr>
          <tr>
            <td>1 kb-2 kb</td>
          </tr>
          <tr>
            <td>2 kb-3 kb</td>
          </tr>
        </table>
        <table class="table cons" style="margin-top: 20px;">
          <tr>
            <th style="width: 150px">片段大小</th>
            <th style="width: 200px">测序深度</th>
            <th style="width: 200px">交付结果</th>
            <th style="width: 200px">备注</th>
          </tr>
          <tr>
            <td>0.3 kb-1 kb</td>
            <td rowspan="4">100X</td>
            <td  rowspan="4">
              1.拼接序列<br>
              2.深度图表
            </td>
            <td  rowspan="4" style="font-size: 12px!important;">
              1.需要提供参考序列;<br>
              2.不保证重复序列区域拼接准确性;<br>
              3.突变5%以上会以简并碱基形式输出。
            </td>
          </tr>
          <tr>
            <td>1 kb-2 kb</td>
          </tr>
          <tr>
            <td>2 kb-3 kb</td>
          </tr>
        </table>
        <div class="c-title c-title1" style="margin-top: 20px;">3、混合片段测序（≥10个样品起送）</div>
        <table class="table con" style="margin-top: 20px;">
          <tr>
            <th style="width: 150px">片段平均大小</th>
            <th style="width: 200px">测序深度</th>
            <th style="width: 200px">交付结果</th>
            <th style="width: 200px">备注</th>
          </tr>
          <tr>
            <td>0.3 kb-0.5 kb</td>
            <td rowspan="4">总深度1000X</td>
            <td  rowspan="4">
              1.拼接序列<br>
              2.深度图表
            </td>
            <td  rowspan="4" style="text-align: left;padding-left: 70px;">
              1.存在序列相似性可能组装失败;<br>
              2.不保证重复序列区域拼接准确性;<br>
              3.客户自行混合好片段池。
            </td>
          </tr>
          <tr>
            <td>0.5 kb-1 kb</td>
          </tr>
          <tr>
            <td>1 kb-2 kb</td>
          </tr>
        </table>
        <table class="table cons" style="margin-top: 20px;">
          <tr>
            <th style="width: 150px">片段平均大小</th>
            <th style="width: 200px">测序深度</th>
            <th style="width: 200px">交付结果</th>
            <th style="width: 200px">备注</th>
          </tr>
          <tr>
            <td>0.3 kb-0.5 kb</td>
            <td rowspan="4">总深度1000X</td>
            <td  rowspan="4">
              1.拼接序列<br>
              2.深度图表
            </td>
            <td  rowspan="4" style="font-size: 12px!important;">
              1.存在序列相似性可能组装失败;<br>
              2.不保证重复序列区域拼接准确性;<br>
              3.客户自行混合好片段池。
            </td>
          </tr>
          <tr>
            <td>0.5 kb-1 kb</td>
          </tr>
          <tr>
            <td>1 kb-2 kb</td>
          </tr>
        </table>
        <div class="c-title c-title1" style="margin-top: 20px;">4、PCR-free分析</div>
        <table class="table con" style="margin-top: 20px;">
          <tr>
            <th style="width: 150px">样品数（个）</th>
            <th style="width: 200px">交付结果</th>
            <th style="width: 200px">备注</th>
          </tr>
          <tr>
            <td>0-30</td>
            <td  rowspan="3" style="text-align: left;padding-left: 70px;">
              1.SNP/Indel统计<br>
              2.PCR产物项目分析报告
            </td>
            <td  rowspan="3" style="text-align: left;padding-left: 70px;">
              1.需要提供参考序列;<br>
              2.品数量=片段数*样品个数;
            </td>
          </tr>
          <tr>
            <td>30-100</td>
          </tr>
        </table>
        <table class="table cons" style="margin-top: 20px;">
          <tr>
            <th style="width: 150px">样品数（个）</th>
            <th style="width: 200px">交付结果</th>
            <th style="width: 200px">备注</th>
          </tr>
          <tr>
            <td>0-30</td>
            <td  rowspan="3" style="font-size: 12px!important;">
              1.SNP/Indel统计<br>
              2.PCR产物项目分析报告
            </td>
            <td  rowspan="3" style="font-size: 12px!important;">
              1.需要提供参考序列;<br>
              2.样品数量=片段数*样品个数;
            </td>
          </tr>
          <tr>
            <td>30-100</td>
          </tr>
        </table>
      </div> -->
      <div class="container">
        <div class="c-title">结果范例</div>
        <div class="result con" style="overflow:auto;">
          <div class="left fl" style="width: 45%;">
            <div class="c-title c-title1" style="color: #13489D;padding: 0!important;">1、全质粒测序结果展示</div>
            <div class="bg">10 kb全质粒测序成环圈图</div>
            <img src="@/assets/img/产品及服务/1.5代测序/1.5_yuan.png" class="img-fluid">
            <!-- <div class="c-title c-title1" style="margin-top: 20px;color: #13489D">2、PCR产物测序结果展示</div>
            <div class="bg">每个碱基深度统计表</div>
            <img src="@/assets/img/产品及服务/1.5代测序/1.5_jianji.png" class="img-fluid"> -->
            <div class="c-title c-title1" style="margin-top: 20px;color: #13489D">2、PCR-free分析结果展示</div>
            <div class="bg">SNP/Indel变异统计表 </div>
            <img src="@/assets/img/产品及服务/1.5代测序/1.5_snp.png" class="img-fluid">
          </div>
          <div class="right fr" style="width: 45%;margin-left: 5%;margin-top: 2%;">
            <div class="bg">质粒FASTA格式文件</div>
            <p class="desc" style="text-indent: 0;line-height: 2.4;padding-bottom: 41px;text-align: start">>序列
              TTCCCAAATTATTCCATCATTAAAAGATACGAGGCGCGTGTAAGTTACAGGCAAGCGATCCGTCAGGTGGCACTTTTCGGGGAAATGTGCGCGGAACCCCTATTTGTTTATTTTTCTAAATACATTCAAATATGTATCCGCTCATGAGACAATAACCCTGATAAATGCTTCAATAATATTGAAAAAGGAAGAGTATGAGTATTCAACATTTCCGTGTCGCCCTTATTCCCTGTTAACGTGCCGGCACGGCCTGGGTAACCAGCGTTCTA</p>
            <!-- <div class="bg">拼接FASTA格式文件</div>
            <p class="desc" style="text-indent: 0;line-height: 2.35;padding-bottom: 39px;">>1_D10_D10_i53.1
              ATGTCATTGACAGTCCAGCTRTCYTTTTCTGGCAGWKCTATAGGCTGKACTGTCCATYTRTCAGGATGGAGTTCATAWCCCATCCAAAGGAATGGRGGTTCYTTYTGATGYTTYTTRTCTGGTGTRGTAARYCCCCASYTCAAYARRTGWKSTCTCAGYTCCTCTATTTTTRTTCTTGYTGCCCTATTTCTAAGATTTTTGTCATGCTACTYTGGAATATTGCTGGTGAYCCTTTCCATCCYT</p> -->
            <div class="bg">PCR分析报告</div>
            <img src="@/assets/img/产品及服务/1.5代测序/1.5_pcr.png" class="img-fluid">
          </div>
        </div>
        <div class="result cons" style="overflow:auto;">
          <div class="left">
            <div class="c-title c-title1" style="color: #13489D;padding: 0!important;">1、全质粒测序结果展示</div>
            <div class="bg">10 K全质粒测序成环圈图</div>
            <img src="@/assets/img/产品及服务/1.5代测序/1.5_yuan.png" class="img-fluid">
            <!-- <div class="c-title c-title1" style="margin-top: 20px;color: #13489D">2、PCR产物测序结果展示</div>
            <div class="bg">每个碱基深度统计表</div>
            <img src="@/assets/img/产品及服务/1.5代测序/1.5_jianji.png" class="img-fluid"> -->
            <div class="c-title c-title1" style="margin-top: 20px;color: #13489D">2、PCR-free分析结果展示</div>
            <div class="bg">SNP/Indel变异统计表 </div>
            <img src="@/assets/img/产品及服务/1.5代测序/1.5_snp.png" class="img-fluid">
          </div>
          <div class="right" style="margin-top: 2%;">
            <div class="bg">质粒FASTA格式文件</div>
            <p class="desc" style="text-indent: 0;line-height: 2.4;padding-bottom: 15px;text-align: start">>序列
              TTCCCAAATTATTCCATCATTAAAAGATACGAGGCGCGTGTAAGTTACAGGCAAGCGATCCGTCAGGTGGCACTTTTCGGGGAAATGTGCGCGGAACCCCTATTTGTTTATTTTTCTAAATACATTCAAATATGTATCCGCTCATGAGACAATAACCCTGATAAATGCTTCAATAATATTGAAAAAGGAAGAGTATGAGTATTCAACATTTCCGTGTCGCCCTTATTCCCTGTTAACGTGCCGGCACGGCCTGGGTAACCAGCGTTCTA</p>
            <!-- <div class="bg">拼接FASTA格式文件</div>
            <p class="desc" style="text-indent: 0;line-height: 2.35;padding-bottom: 15px;">>1_D10_D10_i53.1
              ATGTCATTGACAGTCCAGCTRTCYTTTTCTGGCAGWKCTATAGGCTGKACTGTCCATYTRTCAGGATGGAGTTCATAWCCCATCCAAAGGAATGGRGGTTCYTTYTGATGYTTYTTRTCTGGTGTRGTAARYCCCCASYTCAAYARRTGWKSTCTCAGYTCCTCTATTTTTRTTCTTGYTGCCCTATTTCTAAGATTTTTGTCATGCTACTYTGGAATATTGCTGGTGAYCCTTTCCATCCYT</p> -->
            <div class="bg">PCR分析报告</div>
            <img src="@/assets/img/产品及服务/1.5代测序/1.5_pcr.png" class="img-fluid">
          </div>
        </div>
      </div>
      <div class="container">
        <div class="c-title">服务优势</div>
        <p class="desc" style="text-indent: 0">1.长达30 kb的长片段一次测通</p>
        <p class="desc" style="text-indent: 0">2.高准确率</p>
        <p class="desc" style="text-indent: 0">3.无需引物</p>
        <p class="desc" style="text-indent: 0">4.2H样本制备</p>
        <p class="desc" style="text-indent: 0">5.高通量 </p>
      </div>
      <div class="c-title">资源中心<small>Resource center</small></div>
      <div class="container mt30 mb30">
        <ul class="download">
          <li v-for="item in resourcesLists" :key="item.id">
            {{item.name}}
            <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
          </li>
        </ul>
      </div>
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <div class="container con">
          <ul class="effect-lists">
            <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/Gene_${item.img}${currentType===index ? '' : ''}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
          <ul class="effect-lists">
            <li v-for="(item, index) in types" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <img :src="`/static/img/Gene_${item.img}${currentType===index ? '' : ''}.png`" style="width: 60px;">
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      currentType: -1,
      currentService: -1,
      types: [
        {name: 'Sanger测序', img: '1', ref: '/sanger'},
        {name: '基因组测序', img: '2', ref: '/products/Genome_sequencing'},
        {name: '微生物测序', img: '3', ref: '/products/Microbial_sequencing'},
        {name: '转录组测序', img: '4', ref: '/products/Transcriptome_sequencing'},
      ],
      types1: [
        {name: '全质粒测序',img: '1', ref: '/tec/Whole_plasmid'},
        {name: 'PCR产物测序', img: '2',ref: ''},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/1.5_generation_sequencing.vue